import { type FC, type PropsWithChildren } from 'react'
import styled from 'styled-components'

import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

const UnifiedBoxWrapper = styled.div<{ $hasTakeover: boolean }>(
  ({ theme, $hasTakeover }) => `
  ${
    $hasTakeover
      ? `
    ${MEDIA_QUERIES(theme).large} {
      background: rgba(255, 255, 255, 0.98);
      border-radius: ${theme.borderRadius.small};
      box-shadow: 0 0.4rem 1.2rem rgb(0 0 0 / 15%);
      max-width: 1440px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 4rem;
      pointer-events: auto;
    }
  `
      : ''
  }
`
)

export const TakeoverUnifiedBox: FC<PropsWithChildren> = ({ children }) => {
  const hasTakeover = useTakeoverDetection(GPT_COMPONENT_ID.TAKEOVER)

  return <UnifiedBoxWrapper $hasTakeover={hasTakeover}>{children}</UnifiedBoxWrapper>
}
